import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { ObjectWithId } from '@synergy/models';
import { PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { PaymentTerm } from '../../../../../common/models/payment-term';

export const PAYMENT_CONDITIONS_REQUEST = 'PAYMENT_CONDITIONS_REQUEST';
export const PAYMENT_CONDITIONS_RECEIVED = 'PAYMENT_CONDITIONS_RECEIVED';
export const PAYMENT_CONDITIONS_FAILED = 'PAYMENT_CONDITIONS_FAILED';
export const PAYMENT_CONDITION_DELETE = 'PAYMENT_CONDITION_DELETE';
export const PAYMENT_CONDITION_UPDATE = 'PAYMENT_CONDITION_UPDATE';
export const PAYMENT_CONDITION_CREATE = 'PAYMENT_CONDITION_CREATE';
export const PAYMENT_CONDITION_CREATED = 'PAYMENT_CONDITION_CREATED';

const receivedPaymentTerms = (paymentTerms: PaginatedResponse<PaymentTerm>) => {
    return {
        type: PAYMENT_CONDITIONS_RECEIVED,
        paymentTerms,
    };
};

const createdPaymentTerm = (paymentTerm: PaymentTerm) => {
    return {
        type: PAYMENT_CONDITION_CREATED,
        paymentTerm,
    };
};

export const fetchPaymentTerms = (searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PAYMENT_CONDITIONS_REQUEST });

        const response = await api.paymentTerms.cget(searchParams);

        if (response.success) {
            dispatch(receivedPaymentTerms(response.result));
        } else {
            dispatch({ type: PAYMENT_CONDITIONS_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const deletePaymentTerm = (paymentTermId: number) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.paymentTerms.deletePaymentTerm(paymentTermId);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.paymentTerm.deleted')));
            dispatch({ type: PAYMENT_CONDITION_DELETE, paymentTermId });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const updatePaymentTerm = (paymentTerm: Partial<PaymentTerm> & ObjectWithId) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PAYMENT_CONDITION_UPDATE, paymentTerm });
        const response = await api.paymentTerms.updatePaymentTerm(paymentTerm);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.paymentTerm.updated')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const createPaymentTerm = (paymentTerm: Partial<PaymentTerm>) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PAYMENT_CONDITION_CREATE });
        const response = await api.paymentTerms.createPaymentTerm(paymentTerm);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.paymentTerm.created')));
            dispatch(createdPaymentTerm(response.result));
        } else {
            dispatch({ type: PAYMENT_CONDITIONS_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
